<template>
    <div>
        <textarea ref="editor" v-model="result"></textarea>
    </div>
</template>

<script>
import HtmlMixed from 'codemirror/mode/htmlmixed/htmlmixed';
import CodeMirror from 'codemirror';

export default {
    name: 'string-html',
    props: {
        data: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            result: this.data,
            editor: null
        };
    },
    mounted() {
        this.editor = CodeMirror.fromTextArea(this.$refs.editor, { mode: 'htmlmixed', lineNumbers: true });
        this.editor.on("change", (instance) => { this.result = instance.getValue(); })
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/string/string-html.vue